module.exports = __webpack_public_path__ + "img/snap_01.7daceda1.png";